import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IStagingDataInput } from '../../../interface/interfaces';

interface IInitialState {
    movingLoading: boolean;
    movingData: string;
    movingError: string;
}

const initialState: IInitialState = {
    movingLoading: false,
    movingData: '',
    movingError: '',
};

const movingSlice = createSlice({
    name: 'moving',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchMovingDataPending: (state: IInitialState, action: PayloadAction<IStagingDataInput>) => {
            state.movingLoading = true;
            state.movingData = '';
        },

        fetchMovingDataFulfilled: (state: IInitialState, action: PayloadAction<string>) => {
            state.movingLoading = false;
            state.movingData = action.payload;
            state.movingError = '';
        },
        fetchMovingDataFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.movingLoading = false;
            state.movingData = '';
            state.movingError = action.payload;
        },
    },
});

export default movingSlice.reducer;
export const { fetchMovingDataPending, fetchMovingDataFulfilled, fetchMovingDataFailure } = movingSlice.actions;
